<template>
  <div class="work-h5">
    <!-- <div class="work_header" :style="{backgroundColor:bcColor}">
      <h1>{{title}}</h1>
      <div class="icon" v-if="showBack" @click="goback">
        <van-icon name="arrow-left" />
      </div>
    </div> -->
    <div class="work_content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { Icon } from "vant";
export default {
  components: {
    [Icon.name]: Icon,
  },
  props: {
    title: {
      type: String,
      default: "我的工单",
    },
    bcColor: {
      type: String,
      default: "#ffffff",
    },
  },
  data() {
    return {
      showBack: false,
    };
  },
  mounted() {
    this.setRem();
    // this.isShowBack();
  },
  methods: {
    setRem() {
      // 进入页面 初始化根节点字体大小，宽高rem,字体px
      let contentWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
      // 假定1rem为1px =>（设备宽375）/（设计图宽750）
      // 注意bug qq、uc等浏览器最小根字体大小12px 放大100倍
      let fontSize = (contentWidth / 750) * 100;
      document.documentElement.style.fontSize = fontSize + "px";
      // alert(contentWidth + " " + fontSize);
      // console.log(contentWidth + " " + fontSize);
    },
    isShowBack() {
      let path = this.$route.path;
      if (path.toLowerCase() === "/workOrder".toLowerCase()) {
        this.showBack = false;
        return;
      }
      if (path.toLowerCase() === "/signGoods".toLowerCase()) {
        this.showBack = false;
        return;
      }
      if (path.toLowerCase() === "/workLogin".toLowerCase()) {
        this.showBack = false;
        return;
      }
      this.showBack = true;
    },
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
// 750设计图宽高除100
.work-h5 {
  font-size: 16px;
  color: #333333;
  line-height: 1;
  .work_header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9;
    h1 {
      font-size: 18px;
      font-weight: 400;
    }
    .icon {
      width: 20px;
      height: 20px;
      position: absolute;
      left: 0.3rem;
      top: 50%;
      margin-top: -10px;
      i {
        font-size: 20px;
      }
    }
  }
  // .work_content {
  // padding-top: 0.8rem;
  // }
}
</style>